import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import axiosInstance, { getAPIURL } from "../axiosInstance";

export interface EmailAttachmentPayload {
  email: string;
  name: string;
  subject: string;
  body: string;
  pdfFiles: File[];
}

export const useSendEmailWithAttachments = (
  options?: UseMutationOptions<any, unknown, EmailAttachmentPayload, unknown>
) => {
  return useMutation({
    ...options,
    mutationFn: (data: EmailAttachmentPayload) => {
      const formData = new FormData();

      formData.append("Email", data.email);
      formData.append("Name", data.name);
      formData.append("Subject", data.subject);
      formData.append("Body", data.body);

      data.pdfFiles.forEach((file) => {
        formData.append("PdfFiles", file); // must match API name
      });

      return axiosInstance
        .post(getAPIURL("/Email/SendWithAttachment"), formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        })
        .then((res) => res.data);
    },
  });
};
